import * as s from '@ember/service';

var service = s.service ?? s.inject;

export { service as default };
//# sourceMappingURL=service.js.map
